<template>
    <vPerformanceUnitComponent :postList="postList" v-if="flag"></vPerformanceUnitComponent>
</template>
<script>
import vPerformanceUnitComponent from '../../listComponent/basicdata/performance/performanceUnitComponent.vue';
export default {
    name: 'performance_unit',
    components: {
        vPerformanceUnitComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                parent_code: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>